package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class ConvertToAudiobookRequest(
    val isbn: String? = null,
    val authorName: String? = null,
    val readerName: String? = null,
    val title: String? = null,
    val description: String? = null,
    val labelId: Int? = null
)

@Serializable
data class ConversionResultDto(
    val audiobookId: String,
    val audiobookTitle: String,
    val episodesConverted: Int,
    val downloadsQueued: Int,
    val podcastSoftDeleted: Boolean
)
